<template>
  <div data-app>
    <div class="row" v-if="showBulkMsgForm">
      <div class="col col-md-12" style="display: flex">
        <v-card>
          <v-card-title>
            <span class="headline">You are selected for</span>
          </v-card-title>
          <div class="row" style="padding-left: 6%; padding-right: 6%">
            <div class="col-md-12">
              <v-text-field
                v-model="message_title"
                label="Subject"
              ></v-text-field>

              <v-file-input
                style="font-size: 8px"
                label="file"
                @change="Preview_image"
                v-model="file"
              >
              </v-file-input>
            </div>

            <label>Message</label>
            <vue-editor
              style="width: 100%; height: 80%"
              v-model="message"
            ></vue-editor>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="custom-submit-button"
              text
              @click="showBulkMsgForm = false"
              >Cancel</v-btn
            >
            <v-btn class="custom-cancel-button" text @click="bulkActionHandler"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner
              >Send</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row m-0 p-0">
          <div class="row m-0 col-12 pb-3 bg-white border-r-16">
            <div class="col-md-4 p-0">
              <span class="leatext_job_heading_by_new_home"
                >You are selected for</span
              >
            </div>
            <div
              class="
                col-md-8
                p-0
                row
                m-0
                d-flex
                justify-content-end
                new_list_st_by_ch
              "
            >
              <div class="col-md-12 row m-0 filter_by_ch p-0">
                <div
                  class="count_applicant col text-end p-0"
                  v-if="bulkActionArr.length != 0"
                >
                  {{ bulkActionArr.length }} Applicant selected
                </div>
                <!-- <div
                  class="p-0 mr-4 col-1"
                  
                > -->
                <button
                  v-if="bulkActionArr.length != 0"
                  @click="deleteApp_cann_bulk()"
                  type="button"
                  class="new_details_job_dashbord_list2"
                  style="
                    background: rgba(147, 6, 6, 0.05) !important;
                    border-color: rgba(147, 6, 6, 0.5) !important;
                    padding: 0px !important;
                    min-height: 34px !important;
                    width: 34px !important;
                    height: 34px;
                    margin-right: 10px;
                  "
                >
                  <img
                    class="dashbord"
                    src="\images/job_application/Delete.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                </button>

                <div class="col" v-if="bulkActionArr.length == 0"></div>
                <v-combobox
                  v-model="job_title_filter"
                  class="b_form_slecet_search_save11"
                  style="width: 300px; max-width: 300px; min-width: 300px"
                  :items="jobs"
                  label="Filter by Job vacancy"
                  @change="
                    (e) => {
                      myFunc(e);
                    }
                  "
                >
                  <template>
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </div>
            </div>
          </div>
          <div class="d-none">
            <v-btn
              class="
                btn btn-sm btn-info
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              small
              v-if="bulkActionArr.length > 0"
              @click="showBulkMsgForm = true"
            >
              Bulk Message
            </v-btn>
          </div>

          <div class="row mt-0">
            <div class="col-md-12 row p-0 m-0">
              <div data-app class="p-0">
                <div class="row mt-1 mx-0 new_list_st_by_ch">
                  <div
                    class="row m-0 col-8 py-0 pl-0 pt-4"
                    style="height: fit-content"
                  >
                    <div
                      class="col-md-4 row m-0 pt-0 pr-0"
                      v-for="(item, index) in data.filter(
                        (item) => item.user && item.job
                      )"
                      :key="index"
                      :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''"
                    >
                      <div
                        class="col-md-12 row m-0 border-r-16 p-4"
                        :class="
                          detail1 && detail1.id === item.id
                            ? 'bg-info-new'
                            : 'bg-white' && detail2 && detail2.id === item.id
                            ? 'bg-info-new'
                            : 'bg-white' && detail3 && detail3.id === item.id
                            ? 'bg-info-new'
                            : 'bg-white' && detail4 && detail4.id === item.id
                            ? 'bg-info-new'
                            : 'bg-white'
                        "
                      >
                        <div class="col-md-4 p-0" style="position: relative">
                          <img
                            @error="onImageLoadFailure($event)"
                            :src="mediaUrl + item.compony.profile_pic || ''"
                            alt="Profile Image"
                            id="img_profile"
                            style="
                              width: 74px;
                              height: 74px;
                              border-radius: 50%;
                            "
                          />
                        </div>
                        <div class="col-md-8 p-0 filter_by_ch"></div>

                        <div class="col-md-12 p-0">
                          <span
                            class="label label-info"
                            style="
                              margin: 13px 0 8px 0;
                              background: #e80000;
                              width: auto !important;
                              padding: 0 8px !important;
                              border-radius: 16px !important;
                              font-size: 14px;
                            "
                            v-if="
                              item.notification
                                ? item.notification.seen_at == null
                                : ''
                            "
                            >new</span
                          >
                        </div>
                        <div class="col-md-12 p-0 mt-4">
                          <h4
                            class="mb-0"
                            style="
                              color: #242424;
                              font-size: 18px;
                              font-weight: bold;
                            "
                          >
                            {{ item.compony.company_name }}
                          </h4>
                        </div>
                        <div class="col-md-12 p-0">
                          <p class="m-0" style="color: #666; font-size: 14px">
                            <span v-if="item.short_listed == 'yes'"
                              >Selected for
                            </span>
                            {{ item.job.job_title }}
                          </p>
                        </div>
                        <div class="col-md-12 p-0">
                          <p class="m-0" style="color: #666; font-size: 11px">
                            <span v-if="item.short_listed == 'yes'"
                              >Selected:
                            </span>
                            {{
                              moment(item.job.created_at).format("DD MMM, YY. hh:mmA")
                            }}
                          </p>
                        </div>
                        <hr
                          class="col-md-12 p-0 mt-3"
                          style="background: rgba(53, 162, 229, 0.25)"
                        />
                        <div
                          class="
                            my-0
                            mx-0
                            p-0
                            col-md-12
                            d-flex
                            justify-content-center
                          "
                          style="gap: 5px"
                        >
                          <div class="p-0">
                            <button
                              v-on:click="singleDetail1(item)"
                              @click="
                                notification_read(item.notification.id),
                                  (item.notification.seen_at = 'read')
                              "
                              type="button"
                              class="
                                btn_dash_ch__
                                btn_span_ch
                                new_details_job_dashbord_list
                              "
                            >
                              <img
                                class="dashbord25"
                                src="\images/job_application/Video_icon_.svg"
                                alt=""
                                width="25"
                                height="25"
                              />
                              <div class="light_frozi">Video</div>
                            </button>
                          </div>
                          <div class="p-0">
                            <button
                              v-on:click="singleDetail2(item)"
                              @click="
                                notification_read(item.notification.id),
                                  (item.notification.seen_at = 'read')
                              "
                              type="button"
                              class="
                                btn_dash_ch__
                                btn_span_ch
                                new_details_job_dashbord_list
                              "
                            >
                              <img
                                class="dashbord25"
                                src="\images/job_application/Audio_icon_normal.svg"
                                alt=""
                                width="25"
                                height="25"
                              />
                              <div class="light_frozi">Audio</div>
                            </button>
                          </div>
                          <div
                            class="p-0"
                            v-if="
                              item.short_listed != 'yes' &&
                              item.answered_questions.length > 0
                            "
                          >
                            <button
                              v-on:click="singleDetail4(item)"
                              @click="
                                notification_read(item.notification.id),
                                  (item.notification.seen_at = 'read')
                              "
                              type="button"
                              class="
                                btn_dash_ch__
                                btn_span_ch
                                new_details_job_dashbord_list
                              "
                            >
                              <img
                                class="dashbord25"
                                src="\images/job_application/Q&A_icon_normal.svg"
                                alt=""
                                width="25"
                                height="25"
                              />
                              <div class="light_frozi">Q/A</div>
                            </button>
                          </div>
                          <div class="p-0">
                            <button
                              v-on:click="
                                singleDetail3(item), (item.msgs_counts = 0)
                              "
                              @click="
                                notification_read(item.notification.id),
                                  (item.notification.seen_at = 'read')
                              "
                              type="button"
                              class="
                                btn_dash_ch__
                                btn_span_ch
                                new_details_job_dashbord_list
                              "
                            >
                              <img
                                class="dashbord25"
                                src="\images/job_application/Conversations_icon_normal.svg"
                                alt=""
                                width="25"
                                height="25"
                              />
                              <div class="light_frozi">Chat</div>
                              <span
                                class=""
                                style="
                                  position: absolute;
                                  top: -8px;
                                  right: -15%;
                                  background-color: #e80000 !important;
                                  color: white !important;
                                  border-radius: 50px;
                                  width: 16px;
                                  height: 16px;
                                "
                                v-if="item.msgs_counts > 0"
                                >{{ item.msgs_counts }}</span
                              >
                            </button>
                          </div>
                        </div>
                        <hr
                          class="col-md-12 p-0 mt-3"
                          style="background: rgba(53, 162, 229, 0.25)"
                        />
                        <div class="_btn_gridddd3333 _btn_gridddd p-0 m-0">
                          <div class="p-0 firest" @click="singleDetail1(item)">
                            <button
                              type="button"
                              class="new_details_job_dashbord_list2"
                            >
                              Details
                            </button>
                          </div>
                          <div class="p-0" @click="view_CV(item.cv_path)">
                            <button
                              type="button"
                              class="new_details_job_dashbord_list2"
                            >
                              <span class="v-btn__content">CV</span>
                            </button>
                          </div>
                          <div class="p-0" style="">
                            <button
                              type="button"
                              class="new_details_job_dashbord_list2"
                            >
                              <a
                                target="blank"
                                :href="
                                  '/employer/' +
                                  item.compony.company_name
                                    .toLowerCase()
                                    .replace(/ /g, '-') +
                                  '/' +
                                  item.compony.id
                                "
                              >
                                <span class="v-btn__content">Full Profile</span>
                              </a>
                            </button>
                          </div>
                          <div class="p-0" @click="askUserAboutDelete(item)">
                            <button
                              type="button"
                              class="new_details_job_dashbord_list2"
                              style="
                                background: rgba(147, 6, 6, 0.05) !important;
                                border-color: rgba(147, 6, 6, 0.5) !important;
                              "
                            >
                              <img
                                class="dashbord"
                                src="\images/job_application/Delete.svg"
                                alt=""
                                width="16"
                                height="16"
                              />
                            </button>
                          </div>
                        </div>
                        <div
                          class="col-12 p-0 pt-3 text-center"
                          v-on:click="singleDetail1(item)"
                          @click="
                            notification_read(item.notification.id),
                              (item.notification.seen_at = 'read')
                          "
                          style="
                            font-size: 13px;
                            font-weight: bold;
                            color: rgb(0, 86, 150);
                            cursor: pointer;
                          "
                        >
                          See Full details
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 p-0 sidbar_ch_new3" v-if="detail1">
                    <div class="col-lg-12 pr-0 pt-4 pl-0">
                      <div class="col-md-12 row m-0 p-0">
                        <div
                          class="
                            col-md-12
                            row
                            m-0
                            border-t-lr-16
                            bg-info-new
                            p-4
                          "
                        >
                          <div class="col-md-12 p-0 text-end">
                            <button
                              class="badge badge-danger badge-pill"
                              @click="(detail1 = false), (alwyes = true)"
                            >
                              X
                            </button>
                          </div>
                          <div class="col-md-4 p-0" style="position: relative">
                            <img
                              @error="onImageLoadFailure($event)"
                              :src="
                                mediaUrl + detail1.compony.profile_pic || ''
                              "
                              alt="Profile Image"
                              style="
                                width: 74px;
                                height: 74px;
                                border-radius: 50%;
                              "
                            />
                          </div>
                          <div class="col-md-8 p-0"></div>
                          <div class="col-md-12 p-0 mt-4">
                            <h4
                              class="mb-0"
                              style="
                                color: #242424;
                                font-size: 18px;
                                font-weight: bold;
                              "
                            >
                              {{ detail1.compony.company_name }}
                            </h4>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 14px">
                              <span v-if="detail1.short_listed != 'yes'"
                                >Applied for
                              </span>
                              <span v-if="detail1.short_listed == 'yes'"
                                >Selected for
                              </span>
                              {{ detail1.job.job_title }}
                            </p>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 11px">
                              <span v-if="detail1.short_listed != 'yes'"
                                >Applied:
                              </span>
                              <span v-if="detail1.short_listed == 'yes'"
                                >Selected:
                              </span>
                              {{
                                moment(detail1.job.created_at).format(
                                  "DD MMM, YY. hh:mmA"
                                )
                              }}
                            </p>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div class="_btn_gridddd22_2 _btn_gridddd p-0 m-0">
                            <div class="p-0" @click="view_CV(detail1.cv_path)">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <span class="v-btn__content">View CV</span>
                              </button>
                            </div>
                            <div class="p-0" style="">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <a
                                  target="blank"
                                  :href="
                                    '/employer/' +
                                    detail1.compony.company_name
                                      .toLowerCase()
                                      .replace(/ /g, '-') +
                                    '/' +
                                    detail1.compony.id
                                  "
                                >
                                  <span class="v-btn__content"
                                    >View Full Profile</span
                                  >
                                </a>
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div
                            class="
                              mb-3
                              mt-0
                              mx-0
                              p-0
                              col-md-12
                              d-flex
                              justify-content-center
                            "
                            style="gap: 5px"
                          >
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail11(detail1)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Video_icon_.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Video</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail22(detail1)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Audio_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Audio</div>
                              </button>
                            </div>
                            <div
                              class="p-0"
                              v-if="
                                detail1.short_listed != 'yes' &&
                                detail1.answered_questions.length > 0
                              "
                            >
                              <button
                                v-on:click="singleDetail4(detail1)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Q&A_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Q/A</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="
                                  singleDetail3(detail1),
                                    notification_read(detail1),
                                    (detail1.msgs_counts = 0)
                                "
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Conversations_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Chat</div>
                                <span
                                  class=""
                                  style="
                                    position: absolute;
                                    top: -8px;
                                    right: -15%;
                                    background-color: #e80000 !important;
                                    color: white !important;
                                    border-radius: 50px;
                                    width: 16px;
                                    height: 16px;
                                  "
                                  v-if="detail1.msgs_counts > 0"
                                  >{{ detail1.msgs_counts }}</span
                                >
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                        </div>
                      </div>
                      <div
                        class="
                          col-md-12
                          forvideoFullW
                          row
                          m-0
                          border-b-lr-16
                          bg-info-new
                          pt-0
                          pb-4
                        "
                      >
                        <h5
                          class="p-0 mb-4"
                          style="
                            font-size: 26px;
                            color: #005696 !important;
                            font-weight: bold;
                          "
                        >
                          Video introduction
                        </h5>
                        <video-player
                          class="video-player-box p-0 video_by_ch video_by_ch2"
                          ref="videoPlayer"
                          :options="detail1.videoPlayer"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"
                        >
                        </video-player>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 p-0 sidbar_ch_new3" v-if="detail2">
                    <div class="col-lg-12 pl-0 pt-4 pr-0">
                      <div class="col-md-12 row m-0 p-0">
                        <div
                          class="
                            col-md-12
                            row
                            m-0
                            border-t-lr-16
                            bg-info-new
                            p-4
                          "
                        >
                          <div class="col-md-12 p-0 text-end">
                            <button
                              class="badge badge-danger badge-pill"
                              @click="(detail2 = false), (alwyes = true)"
                            >
                              X
                            </button>
                          </div>
                          <div class="col-md-4 p-0" style="position: relative">
                            <img
                              @error="onImageLoadFailure($event)"
                              :src="
                                mediaUrl + detail2.compony.profile_pic || ''
                              "
                              alt="Profile Image"
                              style="
                                width: 74px;
                                height: 74px;
                                border-radius: 50%;
                              "
                            />
                          </div>
                          <div class="col-md-8 p-0"></div>
                          <div class="col-md-12 p-0 mt-4">
                            <h4
                              class="mb-0"
                              style="
                                color: #242424;
                                font-size: 18px;
                                font-weight: bold;
                              "
                            >
                              {{ detail2.compony.company_name }}
                            </h4>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 14px">
                              <span v-if="detail2.short_listed != 'yes'"
                                >Applied for
                              </span>
                              <span v-if="detail2.short_listed == 'yes'"
                                >Selected for
                              </span>
                              {{ detail2.job.job_title }}
                            </p>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 11px">
                              <span v-if="detail2.short_listed != 'yes'"
                                >Applied:
                              </span>
                              <span v-if="detail2.short_listed == 'yes'"
                                >Selected:
                              </span>
                              {{
                                moment(detail2.job.created_at).format(
                                  "DD MMM, YY. hh:mmA"
                                )
                              }}
                            </p>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div class="_btn_gridddd22_2 _btn_gridddd p-0 m-0">
                            <div class="p-0" @click="view_CV(detail2.cv_path)">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <span class="v-btn__content">View CV</span>
                              </button>
                            </div>
                            <div class="p-0" style="">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <a
                                  target="blank"
                                  :href="
                                    '/employer/' +
                                    detail2.compony.company_name
                                      .toLowerCase()
                                      .replace(/ /g, '-') +
                                    '/' +
                                    detail2.compony.id
                                  "
                                >
                                  <span class="v-btn__content"
                                    >View Full Profile</span
                                  >
                                </a>
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div
                            class="
                              mb-3
                              mt-0
                              mx-0
                              p-0
                              col-md-12
                              d-flex
                              justify-content-center
                            "
                            style="gap: 5px"
                          >
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail11(detail2)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Video_icon_.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Video</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail22(detail2)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Audio_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Audio</div>
                              </button>
                            </div>
                            <div
                              class="p-0"
                              v-if="
                                detail2.short_listed != 'yes' &&
                                detail2.answered_questions.length > 0
                              "
                            >
                              <button
                                v-on:click="singleDetail4(detail2)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Q&A_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Q/A</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="
                                  singleDetail3(detail2),
                                    notification_read(detail2),
                                    (detail2.msgs_counts = 0)
                                "
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Conversations_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Chat</div>
                                <span
                                  class=""
                                  style="
                                    position: absolute;
                                    top: -8px;
                                    right: -15%;
                                    background-color: #e80000 !important;
                                    color: white !important;
                                    border-radius: 50px;
                                    width: 16px;
                                    height: 16px;
                                  "
                                  v-if="detail2.msgs_counts > 0"
                                  >{{ detail2.msgs_counts }}</span
                                >
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                        </div>
                      </div>
                      <div
                        class="
                          col-md-12
                          forvideoFullW
                          row
                          m-0
                          border-b-lr-16
                          bg-info-new
                          pt-0
                          pb-4
                        "
                      >
                        <h5
                          class="p-0 mb-4"
                          style="
                            font-size: 26px;
                            color: #005696 !important;
                            font-weight: bold;
                          "
                        >
                          Audio introduction
                        </h5>
                        <video-player
                          class="video-player-box video_by_ch2 p-0"
                          ref="videoPlayer1"
                          :options="detail2.videoPlayer1"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"
                        >
                        </video-player>
                      </div>
                    </div>
                  </div>
                  <!-- sidbar_ch_new2 for stucky -->
                  <div class="col-lg-4 p-0 sidbar_ch_new3" v-if="detail3">
                    <div class="col-lg-12 pl-0 pr-0">
                      <div class="col-md-12 row m-0 p-0">
                        <div
                          class="
                            col-md-12
                            row
                            m-0
                            border-t-lr-16
                            bg-info-new
                            pb-0
                          "
                        >
                          <div class="col-md-12 p-0 text-end">
                            <button
                              class="badge badge-danger badge-pill"
                              @click="(detail3 = false), (alwyes = true)"
                            >
                              X
                            </button>
                          </div>
                          <div class="col-md-4 p-0" style="position: relative">
                            <img
                              @error="onImageLoadFailure($event)"
                              :src="
                                mediaUrl + detail3.compony.profile_pic || ''
                              "
                              alt="Profile Image"
                              style="
                                width: 74px;
                                height: 74px;
                                border-radius: 50%;
                              "
                            />
                          </div>
                          <div class="col-md-8 p-0"></div>
                          <div class="col-md-12 p-0 mt-4">
                            <h4
                              class="mb-0"
                              style="
                                color: #242424;
                                font-size: 18px;
                                font-weight: bold;
                              "
                            >
                              {{ detail3.compony.company_name }}
                            </h4>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 14px">
                              <span v-if="detail3.short_listed != 'yes'"
                                >Applied for
                              </span>
                              <span v-if="detail3.short_listed == 'yes'"
                                >Selected for
                              </span>
                              {{ detail3.job.job_title }}
                            </p>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 11px">
                              <span v-if="detail3.short_listed != 'yes'"
                                >Applied:
                              </span>
                              <span v-if="detail3.short_listed == 'yes'"
                                >Selected:
                              </span>
                              {{
                                moment(detail3.job.created_at).format(
                                  "DD MMM, YY. hh:mmA"
                                )
                              }}
                            </p>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div class="_btn_gridddd22 _btn_gridddd p-0 m-0">
                            <div class="p-0" @click="view_CV(detail3.cv_path)">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <span class="v-btn__content">CV</span>
                              </button>
                            </div>
                            <div class="p-0" style="">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <a
                                  target="blank"
                                  :href="
                                    '/employer/' +
                                    detail3.compony.company_name
                                      .toLowerCase()
                                      .replace(/ /g, '-') +
                                    '/' +
                                    detail3.compony.id
                                  "
                                >
                                  <span class="v-btn__content"
                                    >Full Profile</span
                                  >
                                </a>
                              </button>
                            </div>
                            <div class="p-0" @click="singleDetail1(detail3)">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                Details
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div
                            class="
                              mb-3
                              mt-0
                              mx-0
                              p-0
                              col-md-12
                              d-flex
                              justify-content-center
                            "
                            style="gap: 5px"
                          >
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail11(detail3)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Video_icon_.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Video</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail22(detail3)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Audio_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Audio</div>
                              </button>
                            </div>
                            <div
                              class="p-0"
                              v-if="
                                detail3.short_listed != 'yes' &&
                                detail3.answered_questions.length > 0
                              "
                            >
                              <button
                                v-on:click="singleDetail4(detail3)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Q&A_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Q/A</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="
                                  singleDetail3(detail3),
                                    notification_read(detail3),
                                    (detail3.msgs_counts = 0)
                                "
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Conversations_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Chat</div>
                                <span
                                  class=""
                                  style="
                                    position: absolute;
                                    top: -8px;
                                    right: -15%;
                                    background-color: #e80000 !important;
                                    color: white !important;
                                    border-radius: 50px;
                                    width: 16px;
                                    height: 16px;
                                  "
                                  v-if="detail3.msgs_counts > 0"
                                  >{{ detail3.msgs_counts }}</span
                                >
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                        </div>
                      </div>
                      <div
                        class="
                          col-md-12
                          forvideoFullW
                          row
                          m-0
                          border-b-lr-16
                          bg-info-new
                          pt-0
                        "
                      >
                        <h5
                          class="p-0 mb-4"
                          style="
                            font-size: 26px;
                            color: #005696 !important;
                            font-weight: bold;
                          "
                        >
                          Massges
                        </h5>
                        <div class="col-12 chat_box_whit_new_styleCH">
                          <div class="chat_box_whit_new_styleCH_child">
                            <div
                              v-if="!messages.length"
                              class="chat_is_not_avilable"
                            >
                              <img
                                src="\images/NoMessages.png"
                                alt="No Messages icon"
                              />
                              <h6 style="font-size: 20px; font-weight: 600">
                                No Messages!
                              </h6>
                              <h6>Send a message to start a conversation.</h6>
                            </div>
                            <div
                              v-for="(_item, _i) in messages"
                              :key="_i"
                              class="v_model_maessages"
                              :class="
                                user.id == _item.sender_id
                                  ? 'Me_side_msg'
                                  : 'you_side_msg'
                              "
                            >
                              <div
                                v-if="detail3.profile"
                                class="profile_img_chat"
                              >
                                <img
                                  @error="onImageLoadFailure($event)"
                                  :src="
                                    mediaUrl + detail3.compony.profile_pic || ''
                                  "
                                  width="23"
                                  v-if="user.id !== _item.sender_id"
                                />
                              </div>
                              <div class="chatBox">
                                <p class="m-0">
                                  <span v-html="_item.message"> </span>
                                </p>
                              </div>
                              <p class="msgTime">
                                {{
                                  moment(_item.created_at).format(
                                    "DD MMMM, YYYY hh:mm A"
                                  )
                                }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="row p-0 m-0 col-md-12 chat_box_ch"
                            style="position: sticky; background: white"
                          >
                            <div class="col-12 p-0">
                              <div class="chat-box-tray row col-12 p-0 m-0">
                                <div class="col-10 p-0">
                                  <input
                                    type="text"
                                    required
                                    placeholder="Type your message here..."
                                    v-model="message"
                                    v-on:keyup.enter="sendMsg(detail3)"
                                  />
                                </div>
                                <div class="col-1 p-0 position-relative">
                                  <v-file-input
                                    class="slect_box_by_ch"
                                    @change="Preview_image"
                                    v-model="file"
                                  >
                                  </v-file-input>
                                </div>
                                <div class="col-1 p-0">
                                  <i
                                    class="material-icons"
                                    @click="
                                      singleMsg(detail3), sendMsg(detail3)
                                    "
                                    >send</i
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 p-0 sidbar_ch_new3" v-if="detail4">
                    <div class="col-lg-12 pl-0 pr-0">
                      <div class="col-md-12 row m-0 p-0">
                        <div
                          class="
                            col-md-12
                            row
                            m-0
                            border-t-lr-16
                            bg-info-new
                            pb-0
                          "
                        >
                          <div class="col-md-12 p-0 text-end">
                            <button
                              class="badge badge-danger badge-pill"
                              @click="(detail4 = false), (alwyes = true)"
                            >
                              X
                            </button>
                          </div>
                          <div class="col-md-4 p-0" style="position: relative">
                            <img
                              @error="onImageLoadFailure($event)"
                              :src="
                                mediaUrl + detail4.compony.profile_pic || ''
                              "
                              alt="Profile Image"
                              style="
                                width: 74px;
                                height: 74px;
                                border-radius: 50%;
                              "
                            />
                          </div>
                          <div class="col-md-8 p-0"></div>
                          <div class="col-md-12 p-0 mt-4">
                            <h4
                              class="mb-0"
                              style="
                                color: #242424;
                                font-size: 18px;
                                font-weight: bold;
                              "
                            >
                              {{ detail4.compony.company_name }}
                            </h4>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 14px">
                              <span v-if="detail4.short_listed != 'yes'"
                                >Applied for
                              </span>
                              <span v-if="detail4.short_listed == 'yes'"
                                >Selected for
                              </span>
                              {{ detail4.job.job_title }}
                            </p>
                          </div>
                          <div class="col-md-12 p-0">
                            <p class="m-0" style="color: #666; font-size: 11px">
                              <span v-if="detail4.short_listed != 'yes'"
                                >Applied:
                              </span>
                              <span v-if="detail4.short_listed == 'yes'"
                                >Selected:
                              </span>
                              {{
                                moment(detail4.job.created_at).format(
                                  "DD MMM, YY. hh:mmA"
                                )
                              }}
                            </p>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div class="_btn_gridddd22 _btn_gridddd p-0 m-0">
                            <div class="p-0" @click="view_CV(detail4.cv_path)">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <span class="v-btn__content">CV</span>
                              </button>
                            </div>
                            <div class="p-0" style="">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                <a
                                  target="blank"
                                  :href="
                                    '/employer/' +
                                    detail4.compony.company_name
                                      .toLowerCase()
                                      .replace(/ /g, '-') +
                                    '/' +
                                    detail4.compony.id
                                  "
                                >
                                  <span class="v-btn__content"
                                    >Full Profile</span
                                  >
                                </a>
                              </button>
                            </div>
                            <div class="p-0" @click="singleDetail1(detail4)">
                              <button
                                type="button"
                                class="new_details_job_dashbord_list2"
                              >
                                Details
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0 mt-3"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                          <div
                            class="
                              mb-3
                              mt-0
                              mx-0
                              p-0
                              col-md-12
                              d-flex
                              justify-content-center
                            "
                            style="gap: 5px"
                          >
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail11(detail4)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Video_icon_.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Video</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="singleDetail22(detail4)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Audio_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Audio</div>
                              </button>
                            </div>
                            <div
                              class="p-0"
                              v-if="
                                detail4.short_listed != 'yes' &&
                                detail4.answered_questions.length > 0
                              "
                            >
                              <button
                                v-on:click="singleDetail4(detail4)"
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Q&A_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Q/A</div>
                              </button>
                            </div>
                            <div class="p-0">
                              <button
                                v-on:click="
                                  singleDetail3(detail4),
                                    notification_read(detail4),
                                    (detail4.msgs_counts = 0)
                                "
                                type="button"
                                class="
                                  btn_dash_ch__
                                  btn_span_ch
                                  new_details_job_dashbord_list
                                "
                              >
                                <img
                                  class="dashbord25"
                                  src="\images/job_application/Conversations_icon_normal.svg"
                                  alt=""
                                  width="25"
                                  height="25"
                                />
                                <div class="light_frozi">Chat</div>
                                <span
                                  class=""
                                  style="
                                    position: absolute;
                                    top: -8px;
                                    right: -15%;
                                    background-color: #e80000 !important;
                                    color: white !important;
                                    border-radius: 50px;
                                    width: 16px;
                                    height: 16px;
                                  "
                                  v-if="detail4.msgs_counts > 0"
                                  >{{ detail4.msgs_counts }}</span
                                >
                              </button>
                            </div>
                          </div>
                          <hr
                            class="col-md-12 p-0"
                            style="background: rgba(53, 162, 229, 0.25)"
                          />
                        </div>
                      </div>
                      <div
                        class="
                          col-md-12
                          forvideoFullW
                          row
                          m-0
                          border-b-lr-16
                          bg-info-new
                          pt-0
                        "
                      >
                        <h5
                          class="p-0 mb-4"
                          style="
                            font-size: 26px;
                            color: #005696 !important;
                            font-weight: bold;
                          "
                        >
                          Answer Questions
                        </h5>
                        <div class="col-12 p-0">
                          <div
                            v-for="(detail4, i) in detail4.answered_questions"
                            :key="i"
                          >
                            <span
                              ><b>Question #{{ i + 1 }}:</b>
                              {{ detail4.question }}</span
                            ><br />
                            <span v-if="detail4.type == 'multi'">
                              <b> Aanswer:</b>
                              {{ JSON.parse(detail4.answer).toString() }}
                            </span>
                            <span v-if="detail4.type != 'multi'">
                              <b> Answer:</b> {{ detail4.answer }} </span
                            ><br /><br />
                          </div>
                          <div
                            class="qa text-center"
                            style="font-size: 20px"
                            v-if="!detail4.answered_questions.length"
                          >
                            No questions were asked by recruiter
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 p-0 alwyes sidbar_ch_new3" v-if="alwyes">
                    <div class="col-lg-12 pl-0 pr-0 pt-4">
                      <div class="card sidebar">
                        <div class="card-body widget cardbodych" style="">
                          <h5
                            class=""
                            style="
                              font-style: normal;
                              font-weight: 700 !important;
                              font-size: 30px;
                              line-height: 120%;
                              color: #005696;
                            "
                          >
          Advertise with  <br />
          job4u.pk
          </h5>
        </div>
        <div class="col-12">
          <p
            style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 140%;
                        color: #666666;
                        background: transparent !important;
                      "
          >
          Contact us to display your
          Ad here to reach tens of
          thousands of people!

          </p>
                          <button
                            style="
                              padding: 12px 16px;
                              gap: 8px;
                              background: #35a2e5;
                              border-radius: 53px;
                              font-style: normal;
                              font-weight: 400;
                              font-size: 16px;
                              line-height: 140%;
                              color: #ffffff;
                            "
                          >
                          <img
              class="dashbord123"
              src="\images/job_application/Call.svg"
              alt=""
              style="margin-right: 10px"
            />
              Contact Sales
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <v-row justify="center">
                  <v-dialog v-model="dialog" persistent max-width="380px">
                    <v-card>
                      <v-card-title>
                        <span class="headline"
                          >Do you really want to DELETE this item?</span
                        >
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="custom-submit-button"
                          text
                          @click="dialog = false"
                          >No</v-btn
                        >
                        <v-btn
                          class="custom-cancel-button"
                          text
                          @click="deleteItem"
                          ><b-spinner
                            small
                            type="grow"
                            v-if="deleting"
                          ></b-spinner
                          >Delete</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import JobSeekerService from "@/MainServices/JobSeekerService.js";
import RecruiterService from "@/MainServices/RecruiterService.js";
import { videoPlayer } from "vue-video-player";
import moment from "moment";

export default {
  data() {
    return {
      mediaUrl: MEDIA_URL,
      loading: true,
      token: `Bearer ${localStorage.getItem("token")}`,
      profile: JSON.parse(localStorage.getItem("profile")),
      user: JSON.parse(localStorage.getItem("user")),
      headers: [
        { text: "Job Title", value: "job_title" },
        { text: "City", value: "location_city" },
        { text: "Salary Min.", value: "salary_min" },
        { text: "Salary Max.", value: "salary_max" },
        { text: "Job Type", value: "job_type" },
        { text: "Job Function", value: "job_function" },
        { text: "Experience", value: "experience" },
        { text: "Education", value: "education" },
        { text: "Gender", value: "gender" },
        { text: "No. of Vacancies", value: "no_of_vacancies" },
        { text: "Expire at", value: "apply_by" },
        { text: "Status", value: "status" },
        { text: "Block", value: "block" },
        { text: "Short List", value: "action" },
      ],
      statusItems: [
        "Shorlisted",
        "Call For Interview",
        "interviewed",
        "Selected",
      ],
      stutas_val: "",
      data: [],
      originalData: [],
      bulkActionArr: [],
      job_id: null,
      job_title_filter: null,
      jobs: [],
      currentMsgUser: null,
      detail1: null,
      detail2: null,
      detail3: null,
      detail4: null,
      alwyes: true,
      // message
      message_title: "",
      message: "",
      conversation: [],
      messages: [],
      file: null,
      file_url: null,
      jobId: null,
      showBulkMsgForm: false,
      dialog: false,
      deleting: false,
    };
  },
  mounted() {
    window.Echo.channel("channel").listen("Notifications", (e) => {
      this.conversation = [];
      let messages = [];
      e.inbox.map((data) => data.map((msg) => messages.push(msg)));
      messages = messages.sort((msg1, msg2) =>
        moment(msg1.created_at)
          .format("X")
          .localeCompare(moment(msg2.created_at).format("X"))
      );
      // .reverse();
      this.conversation = e;
      this.messages = messages;
      // var r_ch = document.getElementsByClassName("v_model_maessages");
      // r_ch[0].scrollTop = r_ch[0].lastElementChild.offsetTop;
    });
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.fetchShortList(false);
    this.fetchCurrentJobs();
  },
  components: {
    videoPlayer,
    VueEditor,
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    fetchShortList(v) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.get(`${API_URL}/selected-for`).then((res) => {
        //sort by created_at
        const combinedArray = res.data;
        // const combinedArray = [...combinedArray_all].sort((a, b) => {
        //   return new Date(b.created_at) - new Date(a.created_at);
        // });
        var temp = [];
        if (v == true) {
          combinedArray.forEach((element) => {
            element.videoPlayer = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "video/mp4",
                  src: this.mediaUrl + "videos/raw/" + element.intro_video,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            element.videoPlayer1 = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "audio/wav",
                  src: this.mediaUrl + "videos/raw/" + element.intro_audio,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            var msgs_counts = 0;

            element.job.threads.map((el) => {
              el.msgs.map((e) => {
                if (
                  e.seen_at == null &&
                  e.receiver_id === this.profile.user_id
                ) {
                  msgs_counts++;
                }
              });
            });
            element.msgs_counts = msgs_counts;
            temp.push(element);
          });
          this.data = temp;
        }
        var temp = [];
        combinedArray.forEach((element) => {
          element.videoPlayer = {
            // videojs options
            muted: true,
            language: "en",
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: [
              {
                type: "video/mp4",
                src: this.mediaUrl + "videos/raw/" + element.intro_video,
              },
            ],
            poster: "/static/images/author.jpg",
          };
          element.videoPlayer1 = {
            // videojs options
            muted: true,
            language: "en",
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: [
              {
                type: "audio/wav",
                src: this.mediaUrl + "videos/raw/" + element.intro_audio,
              },
            ],
            poster: "/static/images/author.jpg",
          };
          var msgs_counts = 0;

          element.job.threads.map((el) => {
            el.msgs.map((e) => {
              if (e.seen_at == null && e.receiver_id === this.profile.user_id) {
                msgs_counts++;
              }
            });
          });
          element.msgs_counts = msgs_counts;
          temp.push(element);
        });
        this.data = temp;
        this.originalData = temp;
      });
    },

    makeToast(variant = null) {
      this.$bvToast.toast("Toast body content", {
        title: `Variant ${variant || "default"}`,
        variant: variant,
        solid: true,
      });
    },

    removeShortList(id) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.delete(`${API_URL}/short-list/${id}`).then((res) => {
        this.$bvToast.toast(res.data.msg, {
          title: `Message`,
          variant: `${res.data.type}`,
          solid: true,
        });
        this.fetchShortList(true);
      });
    },

    fetchCurrentJobs() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/jobs`)
        .then((res) => {
          res.data.forEach((element) => {
            this.jobs.push({
              value: element.id,
              text: element.job_title,
            });
          });
          // this.jobs.unshift(...[{ value: null, text: "select job" }]);

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    myFunc(item) {
      const id = item.value;
      var temp = [];
      this.data = this.originalData;
      this.data.forEach((element) => {
        if (element.job_id == id) {
          temp.push(element);
        }
      });
      // this.job_id = id;
      this.job_title_filter = item.text;
      this.data = temp;
    },
    singleMsg(item) {
      this.currentMsgUser = item;
    },
    Preview_image() {
      this.file_url = this.file;
    },
    resetSendMsg() {
      this.msgUser = null;
      this.message_title = "";
      this.message = "";
      this.file = null;
      this.file_url = null;
      this.sendMsgPopup = false;
      this.currentMsgUser = null;
      setTimeout(() => {
            this.chat_to_bottom();
          }, 100);
    },
    sendMsg() {
      let formData = new FormData();
      formData.append("message_title", this.message_title);
      formData.append("job_id", this.currentMsgUser.job_id);
      formData.append("message", this.message);
      formData.append("receiver_id", this.currentMsgUser.job_seeker_id);
      formData.append("file", this.file_url);

      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/send-message`, formData).then((res) => {
        // Swal.fire({
        //   title: "",
        //   text: res.data,
        //   icon: "success",
        //   confirmButtonClass: "btn btn-secondary",
        //   heightAuto: false,
        // });
        this.resetSendMsg();
      });
    },
    bulkAction(event, item_) {
      var newArr = this.bulkActionArr;
      var id = item_.id;
      if (event == true) {
        newArr.push(id);
        this.bulkActionArr = newArr;
      } else {
        newArr = this.bulkActionArr.filter((item) => {
          return item !== id;
        });
        this.bulkActionArr = newArr;
      }
      // console.log(this.bulkActionArr);
    },
    moment: function (item) {
      return moment(item);
    },
    bulkActionHandler() {
      // return;
      let formData = new FormData();
      formData.append("message_title", this.message_title);
      formData.append("job_id", this.job_id);
      formData.append("message", this.message);
      formData.append("receiver_id", JSON.stringify(this.bulkActionArr));
      formData.append("file", this.file_url);

      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/send-message-bulk`, formData).then((res) => {
        Swal.fire({
          title: "",
          text: res.data,
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        this.showBulkMsgForm = false;
        this.resetSendMsg();
      });
    },
    bulkActionProceed_singel(val, ids) {
      if (val !== "All") {
        const id = [ids];
        RecruiterService.changeJobApplicationStatus({
          ids: id,
          status: val,
          short: "no",
        })
          .then((res) => {
            Swal.fire({
              title: "",
              text: res.data,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.fetchShortList(true);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    bulkActionProceed_singel_short(val, ids) {
      if (val !== "All") {
        const id = [ids];
        RecruiterService.changeJobApplicationStatus({
          ids: id,
          status: val,
          short: "yes",
        })
          .then((res) => {
            Swal.fire({
              title: "",
              text: res.data,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.fetchShortList(true);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    singleDetail1(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail11(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail2(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail22(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail3(item) {
      this.detail3 = item;
      this.getConversation(item);
      this.detail2 = false;
      this.detail1 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail4(item) {
      this.detail4 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail1 = false;
      this.alwyes = false;
    },
    view_CV(path) {
      if (path) {
        //docs.google.com/gview?url=https://api.job4u.pk/public/storage/cvs/2L4ZDNuKi22C8UnqzjGIbavJEGhw8k961J5qeQ0g.pdf&embedded=true
        https: window.open(
          "https://docs.google.com/gview?url=" +
            this.mediaUrl +
            path +
            "&embedded=true",
          "_blank"
        );
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteApp_cann_bulk() {
      const ids = this.bulkActionArr;
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/job-application-delete-bulk`, {
          ids: ids,
        })
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.dialog = false;
          this.loading = false;
          this.success = true;
          this.submitting = false;
          this.bulkActionArr = [];
          this.fetchShortList(true);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteApplication(id) {
      RecruiterService.deleteJobApplication(id)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.dialog = false;
          this.loading = false;
          this.success = true;
          this.submitting = false;
          this.fetchShortList(true);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteItem() {
      this.deleteApplication(this.deleteId);
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    notification_read(id) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/notifications-read`, { id: id }).then((res) => {});
    },
    msg_notification_read(id) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/msg-notifications-read`, { id: id })
        .then((res) => {
          window.location = "/recruiter/job-applications";
        });
    },
    // msg_notification_Bulk(item) {
    //   let ids = item.job.threads;
    //   var count_threds = [];
    //   ids.forEach((element) => {
    //     count_threds.push(element.id);
    //   });
    //   let receiver_id = this.profile.user_id;
    //   axios.defaults.headers.common["Authorization"] = this.token;
    //   axios
    //     .post(`${API_URL}/msg-notifications-Bulk`, { id: count_threds , receiver_id: receiver_id }) .then((res) => {
    //     });
    // },
    getConversation(item) {
      this.thisJobId = item.job_id;
      this.messages = [];
      JobSeekerService.getConversations(item.job_id).then((res) => {
        const messages = [];
        res.data.map((conversation) =>
          conversation.messages.map((msg) => messages.push(msg))
        );
        messages.sort((msg1, msg2) =>
          moment(msg1.created_at)
            .format("X")
            .localeCompare(moment(msg2.created_at).format("X"))
        );
        this.conversation = res.data;
        this.messages = messages;
        setTimeout(() => {
            this.chat_to_bottom();
          }, 100);
      });
    },
    chat_to_bottom() {
      $(".chat_box_whit_new_styleCH_child").scrollTop(
        $(".chat_box_whit_new_styleCH_child")[0].scrollHeight
      );
    },
  },
};
</script>
